import styled from 'styled-components';

import Hint from './Hint';

// @ts-ignore
export default styled(Hint)`
  position: absolute;
  bottom: -18px;
`;
